import { Controller } from "@hotwired/stimulus"
import { createAutocomplete } from "@algolia/autocomplete-core"

export default class extends Controller {
  static targets = ["input", "panel"]
  static values = {
    url: String
  }

connect() {
  this.isPanelManuallyClosed = false

  this.autocomplete = createAutocomplete({
    placeholder: "Search awards...",
    onStateChange: ({ state }) => {
      this.renderPanel(state)
    },
   getSources: () => {
  return [
    {
      sourceId: "awards",
      getItems: async ({ query }) => {
        const response = await fetch(`${this.urlValue}${encodeURIComponent(query)}`)
        const data = await response.json()
        console.log("🎯 API response (awards):", data)

        return (data.awards || []).map((award, index) => ({
          id: award.id,
          slug: award.slug,
          title: award.title,
          __autocomplete_id: `award-${index}`,
          type: "award"
        }))
      }
    },
    {
      sourceId: "categories",
      getItems: async ({ query }) => {
        const response = await fetch(`${this.urlValue}${encodeURIComponent(query)}`)
        const data = await response.json()
        console.log("🎯 API response (categories):", data)

        return (data.categories || []).map((category, index) => ({
          id: category.id,
          slug: category.slug,
          title: category.title,
          __autocomplete_id: `category-${index}`,
          type: "category"
        }))
      }
    }
  ]
    }
  })

  // ✅ Apply autocomplete keyboard + input bindings

  const env = this.autocomplete.getEnvironmentProps({
  inputElement: this.inputTarget
})

Object.assign(this.inputTarget, {
  onKeyDown: env.onKeyDown,
  onFocus: env.onFocus,
  onBlur: env.onBlur
})


  Object.assign(this.inputTarget, env)

  // ✅ Still handle input event for querying
  this.inputTarget.addEventListener("input", (e) => {
    const value = e.target.value
    this.autocomplete.setQuery(value)
    this.autocomplete.refresh()
    this.autocomplete.setIsOpen(value.trim() !== "")
  })


}




renderPanel(state) {
  const { collections = [], query, activeItemId } = state

  console.group(`📦 renderPanel called with ${collections.length} collection(s)`)

  collections.forEach((collection, index) => {
    const sourceId = collection?.source?.sourceId || "unknown"
    const itemCount = Array.isArray(collection?.items) ? collection.items.length : 0
    console.group(`📚 Collection #${index + 1}: ${sourceId} (${itemCount} item${itemCount !== 1 ? "s" : ""})`)
    console.table(collection.items || [])
    console.groupEnd()
  })

  console.groupEnd()

  // Clear previous content
  this.panelTarget.innerHTML = ""

  // Hide panel if query is empty
  if (!query?.trim()) {
    this.panelTarget.classList.add("hidden")
    return
  }

  // Check if there's at least one item to show
  const hasItems = collections.some(col => Array.isArray(col.items) && col.items.length > 0)

  if (!hasItems) {
    const noResults = document.createElement("div")
    noResults.textContent = "No results found"
    noResults.className = "px-4 py-2 text-gray-500"
    this.panelTarget.appendChild(noResults)
    this.panelTarget.classList.remove("hidden")
    return
  }

  this.panelTarget.classList.remove("hidden")

  // Render each group (awards, categories)
  collections.forEach((collection) => {
    if (!Array.isArray(collection.items) || collection.items.length === 0) return

    // Section header
    const sectionTitle = document.createElement("div")
    sectionTitle.textContent =
      collection.source.sourceId === "awards" ? "🏆 Awards" : "📁 Categories"
    sectionTitle.className =
      "px-4 py-2 text-xs font-semibold text-gray-500 uppercase bg-gray-50"
    this.panelTarget.appendChild(sectionTitle)

    // Render each item
    collection.items.forEach((item) => {
      const el = document.createElement("a")

      el.href = item.type === "category"
        ? `/categories/${item.slug}`
        : `/awards/${item.slug}`

      el.textContent = item.title

      const isActive = item.__autocomplete_id === activeItemId
      el.className = `
        block px-4 py-2 text-sm border-b border-gray-100
        ${isActive ? "bg-red-100 text-red-800 font-semibold" : "text-gray-800 hover:bg-gray-100"}
      `.trim()

      this.panelTarget.appendChild(el)
    })
  })
}





  disconnect() {
    this.panelTarget.innerHTML = ""
  }
}
